<template>
    <div>
        <my-search v-model="pgData" @search="searchHandler">
            <el-form-item slot="time">
                <el-input type="text" v-model="pgData.tbdwname" placeholder="请输入单位名称" clearable></el-input>
            </el-form-item>
            <el-form-item slot="title">
    
            </el-form-item>
           
        </my-search>
        <my-table :data="tableData" :height="tableHeight">
            <el-table-column label="标段编码" prop="bdcode" min-width="190" fixed="left"></el-table-column>
            <el-table-column label="标段名称" prop="bdname" min-width="180"></el-table-column>
            <el-table-column label="投标人名称" prop="tbdwname" min-width="140"></el-table-column>
            <el-table-column label="投标保证金" prop="bzjje" width="140"></el-table-column>
            <el-table-column label="虚拟账号" prop="extfszh" min-width="140"></el-table-column>
            <el-table-column label="到帐金额" prop="extdzbzjje" width="140"></el-table-column>
            <el-table-column label="保证金到帐时间" prop="bzjdztime" width="140"></el-table-column>
            <el-table-column label="保证金退款时间" prop="bzjthtime" min-width="140"></el-table-column>
            <el-table-column label="保证金状态" prop="bzjjlcount" width="140">
                <template slot-scope="scope">
                    <span v-if="scope.row.thhsbj == '3'">已退款</span>
                    <span v-else-if="scope.row.thhsbj == '2'">退款已提交银行</span>
                    <span v-else-if="scope.row.thhsbj == '1'">退款财务处理中</span>
                    <span v-else>
                        <span v-if="scope.row.sfyx == true && scope.row.dzhsbj == '1'">已到账</span>
                        <span v-else-if="!!scope.row.bzjdztime && scope.row.sfyx == false">无效</span>
                        <span v-else>未提交</span>
                    </span>
                </template>
            </el-table-column>
            <el-table-column label="虚拟账户交易明细" min-width="150" fixed="right">
                <template slot-scope="scope">
                    <el-button type="success" icon="el-icon-view" @click="see(scope.row.jlcode)" >查看</el-button>
                </template>
            </el-table-column>
        </my-table>
        <my-pagination ref="page" v-model="tableData" :search="pgData" :action="`${getGetters('bidUrl')}/TouBiao/Bzj/bzjjllist.json`">
        </my-pagination>
        <my-dialog v-model="dialogVisible" title="保证金交易明细"  width="1000px">
            <exchange-detail 
                :data="data"
                v-if="dialogVisible"
                @cancle="dialogClose"
            ></exchange-detail>
        </my-dialog>
       
    </div>
</template>

<script>
import FORM_PAGE_MIXIN from '@views/mixins/form-page'
import DIALOG_LIST_PAGE_MIXIN from '@views/mixins/dialog-list-page'
import LIST_PAGE_MIXIN from '@views/mixins/list-page'
import ExchangeDetail from "./exchange_detail.vue";
export default {
    mixins: [LIST_PAGE_MIXIN, FORM_PAGE_MIXIN, DIALOG_LIST_PAGE_MIXIN],
    components: {ExchangeDetail},
    data() {
        return{
            pgData: {
                tbdwname:'',
                bdcode:this.getQuery('bdcode'),
                sortname:'jlcode'
            },
            dialogVisible:false,
            data:""
        }
    },
    computed: {
        
    },
    watch: {

    },
    methods: {
        see(jlcode) {
            this.dialogVisible=true
            this.data=jlcode
        }
    },
    created() {
      
    },
    mounted() {

    }
}
</script>

<style scoped lang="scss">

</style>
